import { useCallback, useState } from "react"
import { Filters, INITIAL_FILTERS } from "./types"

type FilterKey = keyof Filters

export function useSupplierSalesFilters() {
  const [filters, setFilters] = useState<Filters>(INITIAL_FILTERS)

  const setField = useCallback(
    <K extends FilterKey>(key: K, value: Filters[K]) => {
      setFilters((prev) => ({ ...prev, [key]: value }))
    },
    [],
  )

  const reset = useCallback(() => setFilters(INITIAL_FILTERS), [])

  return { filters, setField, reset }
}
